module.exports = __webpack_public_path__ + "static/media/formatosBienestar.2f6c3307.png";